import { ApiBase } from "@/api/ApiBase";
import type { UserAuth } from "@/api/session";

export type TipoNotificacao =
  | "Sistema"
  | "Pagamento"
  | "Venda"
  | "AGT"
  | "OUTRO";
export type LeituraNotificacao = "Pendente" | "Lida";

export interface Notificacao {
  id: number;
  titulo: string;
  mensagem: string;
  leitura: LeituraNotificacao;
  dataCriacao: string;
  bsIcon: string | null;
  tipo: TipoNotificacao;
}

export interface NotificacaoResponse {
  msg: string;
  tipo: "sucesso" | "erro";
  userAuth?: UserAuth;
}

export class NotificacaoApi extends ApiBase {
  listar(pagina: number): Promise<Notificacao[]> {
    return this.http.put<Notificacao[]>(
      `/api/comerciante/notificacao/lista/${pagina}`,
    );
  }

  marcarLida(id: number): Promise<NotificacaoResponse> {
    return this.http.post<NotificacaoResponse>(
      "/api/comerciante/notificacao/marcar-lida",
      { id: String(id) },
    );
  }

  marcarTodasLidas(): Promise<NotificacaoResponse> {
    return this.http.post<NotificacaoResponse>(
      "/api/comerciante/notificacao/marcar-todas-lidas",
    );
  }
}
